module.exports = __webpack_public_path__ + "img/child.b8250ea8.svg";